export default function Icon5() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.5638 9.09141C26.9751 8.48057 27.8036 8.31879 28.4145 8.73005C31.3752 10.7235 33.5919 13.741 34.5551 17.2796C34.7486 17.9902 34.3293 18.7229 33.6188 18.9164C32.9083 19.1098 32.1755 18.6905 31.9821 17.98C31.1906 15.0724 29.3665 12.5858 26.9252 10.9421C26.3143 10.5308 26.1525 9.70224 26.5638 9.09141ZM13.3277 9.15096C13.7444 9.75808 13.5901 10.5881 12.983 11.0048C10.606 12.6363 8.82686 15.0719 8.03622 17.9148C7.83891 18.6242 7.10384 19.0394 6.39438 18.8421C5.68493 18.6448 5.26975 17.9097 5.46706 17.2003C6.42926 13.7405 8.59132 10.7847 11.4739 8.8062C12.081 8.38948 12.911 8.54383 13.3277 9.15096ZM10.1926 30.9784C10.6632 30.412 11.5039 30.3344 12.0702 30.805C14.2217 32.5928 16.9838 33.6667 20.0002 33.6667C22.983 33.6667 25.717 32.6166 27.8579 30.8646C28.4278 30.3982 29.2678 30.4822 29.7342 31.0521C30.2005 31.6219 30.1166 32.462 29.5467 32.9283C26.9469 35.0559 23.6209 36.3333 20.0002 36.3333C16.3385 36.3333 12.9785 35.0269 10.366 32.856C9.7996 32.3854 9.72198 31.5448 10.1926 30.9784Z"
                fill="white"
            ></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.542 6.25002C15.542 4.82329 16.6986 3.66669 18.1253 3.66669H21.8753C23.3021 3.66669 24.4587 4.82329 24.4587 6.25002V10C24.4587 11.4268 23.3021 12.5834 21.8753 12.5834H18.1253C16.6986 12.5834 15.542 11.4268 15.542 10V6.25002Z"
                fill="white"
            ></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.04199 23.125C3.04199 21.6983 4.19859 20.5417 5.62532 20.5417H9.37532C10.8021 20.5417 11.9587 21.6983 11.9587 23.125V26.875C11.9587 28.3018 10.8021 29.4584 9.37532 29.4584H5.62532C4.19859 29.4584 3.04199 28.3018 3.04199 26.875V23.125Z"
                fill="white"
            ></path>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.042 23.125C28.042 21.6983 29.1986 20.5417 30.6253 20.5417H34.3753C35.8021 20.5417 36.9587 21.6983 36.9587 23.125V26.875C36.9587 28.3018 35.8021 29.4584 34.3753 29.4584H30.6253C29.1986 29.4584 28.042 28.3018 28.042 26.875V23.125Z"
                fill="white"
            ></path>
        </svg>
    );
}
